import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { Observable, map } from 'rxjs'
import { AnnouncementAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import {
  fetch_announcement_details,
  save_announcement_action,
  update_announcement_action
} from 'src/app/store/action/announcement.action'
import { getAnnouncementDetails } from 'src/app/store/selector/announcement.selector'

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  invokeAnnouncementSummaryAPI = (queryParams: { key: string; value: string }[], searchRequestBody) => {
    return this.webservice
      .post(ServiceUrlConstants.API_ANNOUNCEMENT_LIST, searchRequestBody, null, queryParams)
      .pipe(map((data: PaginatedAPI<AnnouncementAPIModel>) => data))
  }

  dispatchFetchAnnouncementDetailsAction(id: AnnouncementAPIModel) {
    return this.appState.dispatch(fetch_announcement_details({ id }))
  }

  dispatchSaveAnnouncementAction(announcement: AnnouncementAPIModel, files: File[], routeTo: string) {
    this.appState.dispatch(save_announcement_action({ announcement, files, routeTo }))
  }

  dispatchUpdateAnnouncementAction(
    id: AnnouncementAPIModel,
    announcement: AnnouncementAPIModel,
    files: File[],
    routeTo: string
  ) {
    this.appState.dispatch(update_announcement_action({ id, announcement, files, routeTo }))
  }

  getAnnouncementDetailsFromStore = (): Observable<AnnouncementAPIModel> => {
    return this.appState.select(getAnnouncementDetails())
  }

  callSaveApi = (announcement: AnnouncementAPIModel, files: File[]) => {
    const formData: FormData = new FormData()
    const announcementList = new Blob([JSON.stringify(announcement)], { type: 'application/json' })
    formData.append('announcement', announcementList)

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('documentList', files[i])
      }
    }

    const endPoint = ServiceUrlConstants.API_ANNOUNCEMENT_SAVE_UPDATE
    return this.webservice.post(endPoint, formData, null, [], false).pipe(map((data: AnnouncementAPIModel) => data))
  }

  callUpdateApi = (id: AnnouncementAPIModel, announcement: AnnouncementAPIModel, files: File[]) => {
    const formData: FormData = new FormData()
    const endPoint = `${ServiceUrlConstants.API_ANNOUNCEMENT_SAVE_UPDATE}/${id}`
    const announcementList = new Blob([JSON.stringify(announcement)], { type: 'application/json' })
    formData.append('announcement', announcementList)

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('documentList', files[i])
      }
    }

    return this.webservice.put(endPoint, formData, null, [], false).pipe(map((data: AnnouncementAPIModel) => data))
  }

  callAnnouncementDetailsApi(id: AnnouncementAPIModel) {
    const endPoint = `${ServiceUrlConstants.API_ANNOUNCEMENT_SAVE_UPDATE}/${id}`
    return this.webservice.get(endPoint).pipe(map((data: AnnouncementAPIModel) => data))
  }
}
